import { Directive, inject, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { SessionService } from '@utils/session.service';

@Directive({
  selector: '[showForRoles]',
  standalone: true,
})
export class ShowForRolesDirective {
  @Input('showForRoles') allowedRoles?: string[];

  private sessionService = inject(SessionService);
  private viewContainerRef = inject(ViewContainerRef);
  private templateRef = inject(TemplateRef<any>);

  ngOnInit() {
    return this.sessionService.getRole() === 'SUPERUSER' || (this.allowedRoles && this.allowedRoles.includes(this.sessionService.getRole()))
      ? this.viewContainerRef.createEmbeddedView(this.templateRef)
      : this.viewContainerRef.clear();
  }
}
